import React, { useState } from 'react';
// Context
import { useCTALogClassesData } from '../../../../context/CTALogClassesContext';
// Modules
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { FaPencilAlt } from 'react-icons/fa';
// Components
import DefaultTable from '../../../../components/table/DefaultTable';
import { Column } from '../../../../components/table/components/Types';
import DefaultModal from '../../../../components/modal/DefaultModal';
import CTALogClassForm from './CTALogClassForm';
// Utils
import { ApplicationOptions } from '../../../../utils/Enums';
// Icons
import { FaPlus } from 'react-icons/fa6';
// Styles
import { styleAppCell } from '../../styles/styles';

const CTALogClassesTable = () => {
  // Context
  const { state, dispatch } = useCTALogClassesData();

  // State
  const [showModal, setModalShow] = useState(false);
  const [CTALogClass, setCTALogClass] = useState(null);

  // Methods
  const handleShowModal = () => setModalShow(true);

  const handleCloseModal = () => setModalShow(false);

  const handleEditCTALogClass = (item) => {
    setCTALogClass(item);
    handleShowModal();
  };

  const handleCreateCTALogClass = () => {
    setCTALogClass(null);
    handleShowModal();
  };

  const handleSort = (accessor) => {
    dispatch({
      type: 'SET_SORT',
      payload: {
        type: !state.sort.type || state.sort.type === 'desc' ? 'asc' : 'desc',
        accessor: accessor,
      },
    });
  };

  return (
    <>
      <Row className="my-3">
        <Col className="cta--table-title">
          <h6>Classes</h6>
        </Col>
        <Col className="text-end">
          <Button onClick={handleCreateCTALogClass}>
            <FaPlus /> Classe
          </Button>
        </Col>
      </Row>
      <DefaultTable data={state.data} isLoading={state.loading}>
        <Column header={'Nome'} accessor="name" sorting={{ sort: state.sort, apply: handleSort }} />
        <Column
          header={'Aplicação'}
          accessor="applicationId"
          headerClass="cta--header-app"
          cellClassName="cta--cell-app"
          render={(value, row) => {
            const applicationOption = ApplicationOptions.find((option) => option.id === value);

            return (
              <span className={styleAppCell(applicationOption.name)}>
                {applicationOption ? applicationOption.name : ''}
              </span>
            );
          }}
        />
        <Column
          header={'Ações'}
          headerClass={'width-1'}
          render={(value, row) => {
            return (
              <div className="table--action">
                <span onClick={() => handleEditCTALogClass(row)}>
                  <FaPencilAlt />
                </span>
              </div>
            );
          }}
        />
      </DefaultTable>
      <DefaultModal
        title={CTALogClass && CTALogClass.id !== 0 ? 'Editar módulo' : 'Nova módulo'}
        showModal={showModal}
        handleCloseModal={handleCloseModal}
      >
        <CTALogClassForm CTALogClass={CTALogClass} handleCloseModal={handleCloseModal} />
      </DefaultModal>
    </>
  );
};

export default CTALogClassesTable;
